import * as constants from '../constants';

const tools = require('helpers/tools');

/** ACTION-CREATORS * */

export const actions = {
    getExtraCosts: (customerId) => ({
        type: constants.GET_EXTRA_COSTS,
        customerId,
    }),
    addExtraCost: (customerId, prefill = {}) => {
        const extraCost = Object.assign({}, emptyExtraCost, {
            ...prefill,
            customerId,
        });
        return {
            type: constants.ADD_EXTRA_COST,
            extraCost,
        };
    },
    editExtraCost: (extraCost) => ({
        type: constants.EDIT_EXTRA_COST,
        extraCost,
    }),
    saveExtraCost: (extraCost) => ({
        type: constants.SAVE_EXTRA_COST,
        extraCost,
    }),
    deleteExtraCost: (extraCost) => ({
        type: constants.DELETE_EXTRA_COST,
        extraCost,
    }),
};

const emptyExtraCost = {
    customerId: '',
    employeeId: '',
    agencyId: '',
    fullAmount: '',
    shareLocation: '',
    note: '',
    billedAt: ''
};

/** STATE & MUTATIONS * */
export default function extraCostReducer(
    state = {
        extraCosts: [],
        editItem: null,
        loading: false,
        loadError: false,
        saving: false,
        saveSuccess: false,
        saveError: false,
        deleting: false,
        deleteError: false,
        deleteSuccess: false,
    },
    action
) {
    switch (action.type) {
        case constants.GET_EXTRA_COSTS:
            return tools.update(state, {
                extraCosts: [],
                loading: true,
                loadError: false,
                saveSuccess: false,
                saveError: false,
            });

        case constants.GET_EXTRA_COSTS_ERROR:
            return tools.update(state, {
                extraCosts: [],
                loading: false,
                loadError: action.err,
            });

        case constants.GET_EXTRA_COSTS_SUCCESS:
            return tools.update(state, {
                extraCosts: action.data,
                loading: false,
                loadError: false,
            });

        case constants.ADD_EXTRA_COST:
        case constants.EDIT_EXTRA_COST:
            return tools.update(state, {
                editItem: action.extraCost,
            });

        case constants.EDIT_EXTRA_COST_CANCEL:
            return tools.update(state, {
                editItem: null,
                saveSuccess: false,
                saveError: false,
                saving: false,
            });

        case constants.SAVE_EXTRA_COST:
            return tools.update(state, {
                saving: true,
                saveError: false,
                saveSuccess: false,
            });

        case constants.POST_EXTRA_COST_ERROR:
        case constants.PUT_EXTRA_COST_ERROR:
            return tools.update(state, {
                saving: false,
                saveError: action.err,
                saveSuccess: false,
            });

        case constants.POST_EXTRA_COST_SUCCESS:
            return tools.update(state, {
                saving: false,
                saveError: false,
                saveSuccess: true,
                extraCosts: [...state.extraCosts, action.data.extraCost],
            });

        case constants.PUT_EXTRA_COST_SUCCESS:
            return {
                ...state,
                saving: false,
                saveError: false,
                saveSuccess: true,
                extraCosts: state.extraCosts.map((extraCost) =>
                    extraCost.id === action.data.extraCost.id ? action.data.extraCost : extraCost
                ),
            };

        case constants.DELETE_EXTRA_COST_SUCCESS:
            // Remove deleted item from store
            return tools.update(state, {
                extraCosts: tools.removeItemByProp(state.extraCosts, 'id', action.data.id),
                deleteError: false,
                deleteSuccess: true,
            });

        default:
            return state;
    }
}
